import { VerificationConfig } from '@global/types/form';
import { store } from '@redux/store';
import { VerificationContextType } from 'wallet/containers/form-verification/verification/context';

const checkIfConditionallyRequired = (
  requiredFn: string,
  fields: VerificationContextType['states']['fields'][number],
  verificationName: string,
  fieldName?: string
) => {
  const { formData } = store.getState();
  const { txnInfo } = formData ?? {};
  const verificationOptions = txnInfo?.verificationList?.[verificationName] ?? {};

  if (requiredFn) {
    const isWES = import.meta.env.VITE_ORG === 'WES';
    if (!isWES && fieldName === 'Conferral Form') {
      return false;
    }
    return eval(requiredFn)(fields, verificationOptions);
  }
  return true;
};

export const isRequiredInput = (
  input: VerificationConfig['additionalInfo']['authOptions'][number]['page']['config'][number]['inputs'][number],
  fields: VerificationContextType['states']['fields'][number],
  verificationName: string
) => {
  if (input?.requiredFn) {
    return checkIfConditionallyRequired(input?.requiredFn, fields, verificationName, input?.label);
  }
  return input?.required !== false;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getLabel = (label: string, fieldIdx: number) => {
  return label;
};
